<div nz-col class="query-history-content" nzSpan="24">
  <nz-spin nzTip="Loading..." [nzSize]="'large'" [nzSpinning]="isLoading">
    <div>
      <div class="content">
        <app-query-data-table
          [rows]="queryRecords"
          (reloadQueryHistory)="reloadQueryHistory()"
          [headers]="headers"
        ></app-query-data-table>
      </div>
    </div>
  </nz-spin>
</div>
